module.exports = __webpack_public_path__ + "img/1995_S.c5e8fbe5.png";